import { useTranslation } from "react-i18next";
import logo from "../../assets/pictures/visper-logo.svg";
import styles from "./Header.module.scss";
import LanguageToggle from "../LanguageToggle/LanguageToggle";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { LINKS } from "../../const";
import tgIcon from "../../assets/pictures/icons/telegram-icon-white.svg";

const Header: React.FC = () => {
	const { i18n } = useTranslation();
	const { t } = useTranslation('general');
  	const currentLang = i18n.language as 'ru' | 'en';
	const VISPER_VIDEO_URL = process.env.NX_PUBLIC_VISPER_VIDEO_URL || "";
	const [searchParams, setSearchParams] = useSearchParams();

	const handleLangChange = useCallback((lang: 'ru' | 'en') => {
		const params = new URLSearchParams(searchParams);
    	i18n.changeLanguage(lang);
		params.set('lang', lang);
		setSearchParams(params);
	}, []);

	return (
		<div className={styles.headerContainer}>
			<div className={styles.logoContainer}>
				<a href={VISPER_VIDEO_URL} className={styles.logoLink}>
					<img src={logo} alt="visper logo" className={styles.headerLogo} />
				</a>
				<div className={styles.label}>BETA</div>
			</div>
			<div className={styles.headerActions}>
				<div className={styles.contact}>
					<span className={styles.contactDescription}>{t("contact_us")}</span>
					<a className={styles.button} href={LINKS.telegram} target="_blank" aria-label="telegram">
						<span className={styles.buttonText}>{t("contact_cta")}</span>
						<img className={styles.buttonImg} src={tgIcon} alt="telegram"/>
					</a>
				</div>
				<LanguageToggle currentLang={currentLang} onChange={handleLangChange} />
			</div>
		</div>
	);
};

export default Header;
